import { createAsyncThunk } from '@reduxjs/toolkit';
import notificationApi from '~/apis/notification';
import { GET_NOTIFICATION_LIST, UPDATE_NOTIFICATION_LIST } from '~/utils/constants/actionType';
import { IParamsNotification } from '~/utils/interface/notification';

export const handleGetNotificationList = createAsyncThunk<any, IParamsNotification>(
  GET_NOTIFICATION_LIST,
  async (params: IParamsNotification, { rejectWithValue }) => {
    try {
      const res = await notificationApi.getNotifications(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateNotificationList = createAsyncThunk<any, IParamsNotification>(
  UPDATE_NOTIFICATION_LIST,
  async (params: IParamsNotification, { rejectWithValue }) => {
    try {
      const res = await notificationApi.updateNotifications();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
